import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect } from 'react';
import { Safe } from '../../components/ui/Swicons';
const Features = () => {
  useEffect(()=>{
    AOS.init();
  })

  return (
    <div>
        <section class="m-4 md:m-8 bg-white">
	<div class="container mx-auto p-10 my-6 space-y-2 text-center mt-12">
		<h2 class="text-4xl font-bold">Get smarter with your money transfers</h2>
		<p class="text-xl">We are the fastest and cheapest way to send money worldwide and <br/>are more secure and reliable than using traditional banks. </p>
	</div>
	<div class="w-3/4 mx-auto grid justify-center gap-8 sm:grid-cols-2 lg:grid-cols-3 mt-6">
		<div class="flex flex-col items-center p-10" data-aos="fade-right" data-aos-duration="20" data-aos-offset="100">
			<svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="30"
      viewBox="0 0 24 24"
    >
      <g>
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g>
            <path fillRule="nonzero" d="M0 0H24V24H0z"></path>
            <path
              stroke="#4c9bdc"
              strokeLinecap="round"
              strokeWidth="2"
              d="M19 7H5m15 10H5"
            ></path>
            <path
              stroke="#4c9bdc"
              strokeLinecap="round"
              strokeWidth="2"
              d="M16 3l3.293 3.293a1 1 0 010 1.414L16 11M8 13l-3.293 3.293a1 1 0 000 1.414L8 21"
            ></path>
          </g>
        </g>
      </g>
    </svg>
			<h3 class="my-3 text-2xl font-semibold text-center">Ease of Transfer</h3>
			<div class="space-y-1 leading-tight text-center">
				<p>ScopeX is simple, fast, and hassle-free, so you can transfer money with ease.</p>
			</div>
		</div>
		<div class="flex flex-col items-center p-10" data-aos="fade-right" data-aos-duration="20" data-aos-offset="100">
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="30"
      fill="#72b0e3"
      stroke="#72b0e3"
      version="1.1"
      viewBox="0 0 256 256"
      xmlSpace="preserve"
    >
      <path d="M163 88.74v8.31l-84.989 84.989v-8.31L163 88.74zM43 180l89.833-89.833v-8L43 171.56V180zM248 8v224l-16 16H13.56l24-24h186.47V32H32v186.24L8.03 242.21V24l16-16H248zm-13.62 8H32v8h194.38l8-8zm5.65 5.66L232 29.69V224h8.03V21.66zM78.018 108.672L133 53.69v-8.31l-54.982 54.982v8.31z"></path>
    </svg>
			<h3 class="my-3 text-2xl font-semibold text-center">Transperancy</h3>
			<div class="space-y-1 leading-tight text-center">
				<p>We ensure all our fees and exchange rates are clearly displayed upfront, so you know what you're getting.</p>
			</div>
		</div>
		<div class="flex flex-col items-center p-10" data-aos="fade-right" data-aos-duration="20" data-aos-offset="100">
			<Safe/>
			<h3 class="my-3 text-2xl font-semibold text-center">Safe Money Transfer</h3>
			<div class="space-y-1 leading-tight text-center">
				<p>We use the latest encryption technology to keep your funds safe and secure during every step of the transfer process.</p>
			</div>
		</div>
		<div class="flex flex-col items-center p-10" data-aos="fade-right" data-aos-duration="20" data-aos-offset="200">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#4c9bdc" width="35"
      height="30">
				<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"></path>
			</svg>
			<h3 class="my-3 text-2xl font-semibold text-center">Quick support</h3>
			<div class="space-y-1 leading-tight text-center">
				<p>Our dedicated support team is always available to answer any questions or concerns.</p>
			</div>
		</div>
		<div class="flex flex-col items-center p-10" data-aos="fade-right" data-aos-duration="20" data-aos-offset="200">
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="30"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g
        stroke="#4c9bdc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          strokeMiterlimit="10"
          d="M7.48 18.35l3.1 2.4c.4.4 1.3.6 1.9.6h3.8c1.2 0 2.5-.9 2.8-2.1l2.4-7.3c.5-1.4-.4-2.6-1.9-2.6h-4c-.6 0-1.1-.5-1-1.2l.5-3.2c.2-.9-.4-1.9-1.3-2.2-.8-.3-1.8.1-2.2.7l-4.1 6.1"
          opacity="0.4"
        ></path>
        <path d="M2.38 18.35v-9.8c0-1.4.6-1.9 2-1.9h1c1.4 0 2 .5 2 1.9v9.8c0 1.4-.6 1.9-2 1.9h-1c-1.4 0-2-.5-2-1.9z"></path>
      </g>
      <g stroke="#4c9bdc" strokeWidth="1.5">
        <path
          strokeMiterlimit="10"
          d="M7.48 18.35l3.1 2.4c.4.4 1.3.6 1.9.6h3.8c1.2 0 2.5-.9 2.8-2.1l2.4-7.3c.5-1.4-.4-2.6-1.9-2.6h-4c-.6 0-1.1-.5-1-1.2l.5-3.2c.2-.9-.4-1.9-1.3-2.2-.8-.3-1.8.1-2.2.7l-4.1 6.1"
          opacity="0.4"
        ></path>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.38 18.35v-9.8c0-1.4.6-1.9 2-1.9h1c1.4 0 2 .5 2 1.9v9.8c0 1.4-.6 1.9-2 1.9h-1c-1.4 0-2-.5-2-1.9z"
        ></path>
      </g>
    </svg>
			<h3 class="my-3 text-2xl font-semibold text-center">Satisfied Customers</h3>
			<div class="space-y-1 leading-tight text-center">
				<p>We have a proven track record of satisfied customers who trust us to transfer their money safely and securely.</p>
			</div>
		</div>
		<div class="flex flex-col items-center p-10" data-aos="fade-right" data-aos-duration="20" data-aos-offset="200">
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="30"
      fill="#58a8ff"
      className="cf-icon-svg"
      viewBox="-2 0 19 19"
    >
      <path d="M14.443 4.445a1.615 1.615 0 01-1.613 1.614h-.506v8.396a1.615 1.615 0 01-1.613 1.613H2.17a1.613 1.613 0 110-3.227h.505V4.445A1.615 1.615 0 014.289 2.83h8.54a1.615 1.615 0 011.614 1.614zM2.17 14.96h7.007a1.612 1.612 0 010-1.01H2.172a.505.505 0 000 1.01zm9.045-10.515a1.62 1.62 0 01.08-.505H4.29a.5.5 0 00-.31.107l-.002.001a.5.5 0 00-.193.397v8.396h6.337a.61.61 0 01.6.467.632.632 0 01-.251.702.505.505 0 10.746.445zm-.86 1.438h-5.76V6.99h5.76zm0 2.26h-5.76V9.25h5.76zm0 2.26h-5.76v1.108h5.76zm2.979-5.958a.506.506 0 00-.505-.505.496.496 0 00-.31.107h-.002a.501.501 0 00-.194.398v.505h.506a.506.506 0 00.505-.505z"></path>
    </svg>
			<h3 class="my-3 text-2xl font-semibold text-center">Fair and Open Policy</h3>
			<div class="space-y-1 leading-tight text-center">
				<p>We have a clear policy that outlines our fees, exchange rates, and all other details, so you can be confident in the service you get.</p>
			</div>
		</div>
	</div>
</section>
    </div>
  )
}

export default Features;